import $ from 'jquery';
import {checkForWrongEventTarget} from "./checkForWrongEventTarget";

export class RadioOption {
    constructor(domNode) {
        this.domNode = domNode;
        this.radioInput = domNode.querySelector('input[type="radio"]');
        this.textInput = domNode.querySelector('.input-element');

        this.isChecked() && this.isVisible() ? this.setChecked() : this.setUnchecked();
    }

    addKeyListener(listener) {
        this.domNode.addEventListener('keydown', event => listener(event, this));
    }

    addClickListener(listener) {
        ['click'].forEach(evt => this.domNode.addEventListener(evt, event => {
            if (checkForWrongEventTarget(event.target, 'radio')) {
                return;
            }

            listener(event, this);
        }));
    }

    isVisible() {
        return $(this.domNode).is(':visible');
    }

    focus() {
        this.domNode.focus();
    }

    isChecked() {
        return this.radioInput.checked;
    }

    isAriaChecked() {
        return this.domNode.getAttribute('aria-checked') == 'true';
    }

    setChecked() {
        this.radioInput.checked = true;
        this.setPropertiesForChecked();
        this.focusInputField();
    }

    setUnchecked() {
        this.radioInput.checked = false;
        this.setPropertiesForUnchecked();
    }

    setAccessible(accessible) {
        this.domNode.setAttribute('tabindex', accessible ? 0 : -1);
    }

    hasInputField() {
        return this.textInput !== null;
    }

    focusInputField() {
        if (this.hasInputField()) {
            this.textInput.focus();
        }
    }

    setPropertiesForChecked() {
        this.domNode.setAttribute('aria-checked', 'true');
        this.radioInput.setAttribute('checked', 'checked');
        this.domNode.classList.add('option-checked');
        this.domNode.setAttribute('tabindex', 0);

        if (this.hasInputField()) {
            this.textInput.setAttribute('tabindex', 0);
        }

    }

    setPropertiesForUnchecked() {
        this.domNode.setAttribute('aria-checked', 'false');
        this.radioInput.removeAttribute('checked');
        this.domNode.classList.remove('option-checked');
        this.domNode.setAttribute('tabindex', -1);

        if (this.hasInputField()) {
            this.textInput.setAttribute('tabindex', -1);
        }
    }
}